import Link from "next/link"
import { ShortArrow } from "../home/card"

interface NextPreviousProps {
  workCtxData?: Array<any>
  record_id: string
  category: Array<string> | undefined
  worksNav: string
}

export const NextPrevious = (props: NextPreviousProps) => {
  const { workCtxData, record_id, category, worksNav } = props

  // get the total number of works in this category array
  const total = workCtxData && workCtxData.length - 1
  // Find the index of the current work in the category array
  const currentIndex = workCtxData && workCtxData.map((item) => item.id).indexOf(record_id)

  const first = currentIndex == 0
  const last = currentIndex == total
  const prev = currentIndex && currentIndex != 0 && workCtxData ? workCtxData[currentIndex - 1] : undefined
  const next =
    (currentIndex == 0 || (currentIndex && currentIndex != total) || (currentIndex && currentIndex > 0)) && workCtxData
      ? workCtxData[currentIndex + 1]
      : undefined

  const firstLastPath = worksNav == "overview" ? `/works/` : `/works/${worksNav}`
  const categoryName = worksNav == "overview" ? "Overview" : category && `All ${category[0]}`

  return (
    <div tw="py-2 flex justify-between w-full tablet:(w-mobile-lg)">
      {prev && (
        <Link tw="space-x-2 text-sm flex items-center" href={`/works/${prev.fields.id}/`}>
          <span tw="rotate-180">{ShortArrow}</span> <span>Previous</span>
        </Link>
      )}
      {first && (
        <Link tw="space-x-2 text-sm flex items-center" href={firstLastPath}>
          <span tw="rotate-180">{ShortArrow}</span> <span>{`${categoryName}`}</span>
        </Link>
      )}
      {next && (
        <Link tw="space-x-2 text-sm flex items-center text-right" href={`/works/${next.fields.id}/`}>
          <span>Next</span> <span>{ShortArrow}</span>
        </Link>
      )}
      {last && (
        <Link tw="space-x-2 text-sm flex items-center text-right" href={firstLastPath}>
          <span>{`${categoryName}`}</span>
          <span>{ShortArrow}</span>
        </Link>
      )}
    </div>
  )
}
